<template>
  <q-dialog
    v-model="showDialog"
    transition-show="slide-left"
    transition-hide="slide-right"
    full-height
    full-width
  >
    <div class="container">
      <q-toolbar>
        <q-icon size="md" class="text-grey-7" round dense name="info" />
        <q-toolbar-title
          ><span class="toolbar-title">INFORMATION </span></q-toolbar-title
        >
        <q-btn flat v-close-popup round dense icon="close" />
      </q-toolbar>
      <div class="q-pa-md">
        <slot></slot>
      </div>
    </div>
  </q-dialog>
</template>
<style scoped>
.container {
  background-color: #fff;
  color: #000;
}
.toolbar-title {
  font-size: 13px;
}
</style>
<script>
export default {
  name: "DCardModalInfo",
  props: {
    show: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      lshow: false,
    };
  },
  watch: {
    show: function () {
      this.showDialog = !this.showDialog;
    },
  },
  computed: {
    showDialog: {
      get() {
        return this.lshow;
      },
      set(val) {
        this.lshow = val;
      },
    },
  },
};
</script>
